import { money } from "@/lib/api";
import { ACCOUNT } from "@/constants/testIds";

export const OrderCard = ({ order }) => (
  <div data-testid={ACCOUNT.order(order.order_id)} className="bg-white border border-[#F0EBE1] rounded-[1.5rem] p-5">
    <div className="flex flex-wrap justify-between gap-2 text-sm">
      <span className="font-heading font-bold text-base">{order.order_id}</span>
      <span className="text-stone-500">{new Date(order.created_at).toLocaleDateString()}</span>
    </div>
    <ul className="mt-4 space-y-2 text-sm text-stone-600">
      {order.lines.map((l) => (
        <li key={l.slug} className="flex justify-between gap-4"><span>{l.qty} × {l.name}</span><span>{money(l.price * l.qty)}</span></li>
      ))}
    </ul>
    <div className="mt-4 pt-3 border-t border-[#F0EBE1] flex justify-between text-sm">
      <span className="capitalize px-3 py-1 rounded-full bg-[#E8F0EC] text-[#2C5242]">{order.status === "shipped" ? `Shipped${order.tracking ? ` · ${order.tracking}` : ""}` : order.payment_status === "paid" ? "Paid · preparing to ship" : order.payment_status}</span>
      <span className="font-semibold">{money(order.amount_paid ?? order.total)}</span>
    </div>
  </div>
);
